<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Collaboration } from '@openapi'
import CCard from '@lib/components/CCard/CCard.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'

interface Props {
  items: Collaboration[]
  maxItemsToShow?: number
  title?: string
}

const props = withDefaults(defineProps<Props>(), {
  maxItemsToShow: 5,
})

const { t } = useI18n()
const themeVars = useThemeVars()

const itemsToShow = computed(() => props.items.slice(0, props.maxItemsToShow))
</script>

<template>
  <CCard class="pa-2 c-files-access-info">
    <div class="flex flex-col gap-6">
      <div class="flex items-center gap-4">
        <CIcon icon="folder" />
        <div class="font-bold">
          {{ title ?? t('canvasUI.components.CFilesAccessInfo.title', items.length) }}
        </div>
      </div>

      <div class="flex flex-wrap">
        <div v-for="({ file }, index) in itemsToShow.slice(0, maxItemsToShow)" :key="file.id">
          <span>{{ file.name }}</span>
          <span v-if="index < itemsToShow.length - 1">,&nbsp;</span>
        </div>
        <div v-if="items.length > maxItemsToShow" class="ml-2 truncate c-files-access-info__more">
          {{ t('canvasUI.components.CFilesAccessInfo.more', items.length - maxItemsToShow) }}
        </div>
      </div>
    </div>

    <slot />
  </CCard>
</template>

<style lang="scss" scoped>
.c-files-access-info {
  &__more {
    color: v-bind('themeVars.text2');
  }
}
</style>
